// extracted by mini-css-extract-plugin
export default {"container":"header_container__AzWgZ","label":"header_label__jn5Xv"};